import React from 'react';
import { Container, StyledContent } from './Content.css';
import WordpressRawContent from '../WordpressRawContent';
import Share from '../Sharer';

const Content = ({ title, image, excerpt, titulo, subtitulo, raw, video, slug }) => {
	return (
		<Container>
			<StyledContent>
				<h2>{title}</h2>
				<WordpressRawContent raw={raw} />
				<div className="share-wrap">
					<Share
						socialConfig={{
							twitterHandle: '@cultolt',
							config: {
								url: `https://especiales.latercera.com/culto-the-cure/${slug}/`,
								title: `${title} - The Cure: treinta años de Disintegration - Culto`,
								via: 'cultolt'
							}
						}}
					/>
				</div>
			</StyledContent>
		</Container>
	);
};

export default Content;
